var e = function e(_e) {
    Object.defineProperty(_e, "suppressToggle", {
      value: !0,
      writable: !1
    });
  },
  s = function s(e) {
    return (e.nativeEvent || e).suppressToggle;
  };
export { s as isToggleSuppressed, e as suppressToggle };